import React, { useState, useEffect } from "react";
import { Bar } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";
import { api } from '../../api/apiService';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ChartDataLabels
);

const OnTimeCheck = () => {
    const [view, setView] = useState("month");
    const [chartData, setChartData] = useState({ labels: [], datasets: [] });
    const [totalEmployees, setTotalEmployees] = useState(0);

    useEffect(() => {
        const fetchData = async () => {
            let url = '';
            if (view === 'month') {
                const now = new Date();
                const month = now.getMonth() + 1;
                const year = now.getFullYear();
                url = `/reports/charts/on-time?view=month&month=${month}&year=${year}`;
            } else {
                const today = new Date();
                const day = today.getDay();
                const monday = new Date(today);
                monday.setDate(today.getDate() - (day === 0 ? 6 : day - 1));
                const weekStart = monday.toISOString().split('T')[0];
                url = `/reports/charts/on-time?view=week&week_start=${weekStart}`;
            }
            const response = await api.get(url);
            const payload = response.data?.data ?? response.data;
            const meta = response.data?.meta ?? response.meta;
            setChartData({ labels: payload.labels || [], datasets: payload.datasets || [] });
            setTotalEmployees(meta?.total_employees || 0);
        };
        fetchData();
    }, [view]);

    const yCap = totalEmployees > 0 ? totalEmployees : 100;

    const options = {
        responsive: true,
        plugins: {
            legend: { position: "bottom" },
            datalabels: {
                display: false,
            },
            tooltip: {
                callbacks: {
                    label: function (context) {
                        return context.dataset.label + ": " + Math.abs(context.raw);
                    },
                },
            },
        },
        scales: {
            x: {
                stacked: true,
                ticks: {
                    maxRotation: 90,
                    minRotation: 45,
                },
            },
            y: {
                stacked: true,
                min: -yCap,
                max: yCap,
            },
        },
    };

    return (
        <div className="chart-onTimeCheck">
            <div className="chart-header">
                <h4 className="text-muted text-sm font-semibold">ON Time Check In/Out</h4>
                <select
                    value={view}
                    onChange={(e) => setView(e.target.value)}
                    className="chart-dropdown"
                >
                    <option value="month">This Month</option>
                    <option value="week">This Week</option>
                </select>
            </div>
            <Bar
                data={chartData}
                options={options}
                className="chart-canvas"
            />
        </div>
    );
};

export default OnTimeCheck;
